import { render, staticRenderFns } from "./StudentBillingStatusPicker.vue?vue&type=template&id=b96963f6&scoped=true&"
import script from "./StudentBillingStatusPicker.vue?vue&type=script&lang=js&"
export * from "./StudentBillingStatusPicker.vue?vue&type=script&lang=js&"
import style0 from "./StudentBillingStatusPicker.vue?vue&type=style&index=0&id=b96963f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96963f6",
  null
  
)

export default component.exports